import axios, { AxiosError, AxiosRequestConfig } from "axios"
import { RetentionUploadRequest } from "types/request"
import {
  CLIENT_RETENTION_PATH,
  RETENTIONS_PATH,
  UPLOAD_PATH,
} from "../../constants/paths"
import { RetentionUploadResponse } from "types/response"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})

const formDataConfig: AxiosRequestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
}

export const uploadRetentionsService = async (
  data: RetentionUploadRequest[]
): Promise<RetentionUploadResponse> => {
  const formData = new FormData()
  data.forEach((retention, index) => {
    formData.append(
      `retentions[${index}].documentId`,
      retention.documentId.toString()
    )
    formData.append(`retentions[${index}].serialNumber`, retention.serialNumber)
    formData.append(`retentions[${index}].retentionKey`, retention.retentionKey)
    formData.append(
      `retentions[${index}].retainedValue`,
      retention.retainedValue
    )
    // PDF (solo si existe)
    if (retention.pdf) {
      formData.append(`retentions[${index}].pdf`, retention.pdf)
    }

    // ---- Customer ----
    formData.append(
      `retentions[${index}].infoCustomer.customerCode`,
      retention.infoCustomer.customerCode
    )

    formData.append(
      `retentions[${index}].infoCustomer.customerIdentification`,
      retention.infoCustomer.customerIdentification
    )

    formData.append(
      `retentions[${index}].infoCustomer.customerName`,
      retention.infoCustomer.customerName
    )
  })

  try {
    const result = await instance.post(
      CLIENT_RETENTION_PATH + UPLOAD_PATH + RETENTIONS_PATH,
      formData,
      formDataConfig
    )
    return result.data as RetentionUploadResponse
  } catch (error) {
    throw new Error((error as AxiosError)?.response?.data)
  }
}
